<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 214.808"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M55.478 105.746c-3.314,0.726 -6.648,0.969 -10.001,0.729 0.353,23.073 -0.37,56.098 0.769,93.625 5.204,-30.504 8.28,-61.955 9.232,-94.354z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M65.964 67.939c-8.644,-4.657 -20.097,-2.631 -34.361,6.08 0.195,0.612 0.397,1.214 0.608,1.807 4.326,12.173 12.043,20.311 21.521,22.116 6.059,-0.911 11.12,-5.941 15.079,-13.293 1.67,-3.101 3.144,-6.616 4.415,-10.408 -2.148,-2.75 -4.569,-4.85 -7.262,-6.302z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthRight}"
            @click="select('fourthRight')"
            d="M60.822 42.044c5.861,0.385 12.05,0.195 18.566,-0.57 0.936,-7.497 1.639,-15.748 -0.182,-20.346 -3.288,-8.304 -10.742,-10.87 -18.413,-11.628 -0.68,12.402 -0.67,23.25 0.029,32.544z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdRight}"
            @click="select('thirdRight')"
            d="M79.388 41.474c-6.516,0.765 -12.705,0.955 -18.566,0.57 0.803,10.685 2.517,19.317 5.142,25.895 2.693,1.452 5.114,3.552 7.262,6.302 2.359,-7.043 4.016,-15.044 4.921,-23.139 0.306,-2.736 0.799,-6.099 1.241,-9.628z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M65.964 67.939c-2.625,-6.578 -4.339,-15.21 -5.142,-25.895 -0.699,-9.294 -0.709,-20.142 -0.029,-32.544 -2.683,-0.265 -5.392,-0.309 -7.959,-0.3 -2.213,0.009 -4.999,-0.467 -7.884,-0.957 0.415,21.658 1.989,42.207 4.438,58.024 6.355,-1.416 11.88,-0.858 16.576,1.672z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthLeft}"
            @click="select('fourthLeft')"
            d="M46.548 41.252c-0.831,-10.329 -1.377,-21.513 -1.598,-33.009 -6.142,-1.045 -12.728,-2.158 -15.158,1.194 -4.611,6.359 -2.669,20.676 -1.751,34.095 11.184,-3.177 15.932,-3.784 18.507,-2.28z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdLeft}"
            @click="select('thirdLeft')"
            d="M46.548 41.252c-2.575,-1.504 -7.324,-0.897 -18.507,2.28 0.207,3.027 0.362,6.007 0.378,8.841 0.044,8.013 1.175,15.326 3.184,21.646 6.514,-3.978 12.443,-6.562 17.785,-7.752 -1.149,-7.422 -2.105,-15.885 -2.84,-25.015z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M32.211 75.826c1.448,53.183 1.327,99.469 7.323,125.997 6.738,15.548 17.367,12.129 19.845,-14.894 3.016,-32.9 4.268,-69.039 9.432,-102.28m-40.392 -32.276c-0.086,-15.397 -4.278,-35.143 1.373,-42.936 3.571,-4.925 16.115,-0.211 23.042,-0.237 9.906,-0.036 21.934,0.72 26.372,11.928 2.678,6.764 -0.103,21.427 -1.059,29.974 -2.549,22.788 -11.053,44.832 -24.415,46.84 -14.709,-2.801 -25.175,-20.857 -25.313,-45.569z"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
